import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { CYTtable } from "./components/cyt.js";
import { CYTPlace } from "./components/place.js";
import { Router } from "@reach/router";
import firebase from "./components/CYTFirebase.js";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

let CYTScreen = props => {
  firebase.analytics().setCurrentScreen("main_listing", props);
  return <CYTtable {...props} />;
};

let CYTCategoryScreen = props => {
  firebase.analytics().setCurrentScreen("category", props);
  return <CYTtable {...props} />;
};

let CYTUserScreen = props => {
  firebase.analytics().setCurrentScreen("user", props);
  return <CYTtable {...props} />;
};
let CYTPlaceScreen = props => {
  firebase
    .analytics()
    .setCurrentScreen("provider_detail", { providerId: props.placeId });
  return <CYTPlace {...props} />;
};

class Cyt extends React.Component {
  render() {
      const THEME = createMuiTheme({
       typography: {
        "fontFamily": `"Noto Sans JP", "Helvetica", "Arial", sans-serif`,
        "fontSize": 14,
        "fontWeightLight": 300,
        "fontWeightRegular": 400,
        "fontWeightMedium": 500
        },
        palette: {
            primary: {
              // light: will be calculated from palette.primary.main,
              main: '#66498C'
              // dark: will be calculated from palette.primary.main,
              // contrastText: will be calculated to contrast with palette.primary.main
            }
          }
      });
    return (
      <MuiThemeProvider theme={THEME}>
        <div>
          <Router>
            <CYTScreen path="/" />
            <CYTCategoryScreen path="c/:categories" />
            <CYTPlaceScreen path="p/:placeId" />
            <CYTUserScreen path=":otherUserVanityURL" />
          </Router>
        </div>
      </MuiThemeProvider>
    );
  }
}



ReactDOM.render(<Cyt />, document.getElementById("root"));
